import PropTypes from "prop-types";
import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import BaseItem from "./components/BaseItem";
import Cart from "./components/Cart";
import Column from "./components/Column";
import Item from "./components/Item";
import Login from "./components/Login";
import NavList from "./components/NavList";
import NavItem from "./components/NavItem";
import { LanguageSelector } from "./components/LanguageSelector";

var GlobalHeader = function GlobalHeader(_ref) {
  var leftItems = _ref.leftItems,
      rightItems = _ref.rightItems,
      showSkipLink = _ref.showSkipLink,
      skipLinkText = _ref.skipLinkText;
  var getClassName = getClassNameFactory(GlobalHeader.displayName);
  var getSlipLinkClassName = getClassNameFactory(GlobalHeader.displaySkipLinkName);
  var root = document.querySelector(".root.container.responsivegrid") || document.querySelector("main");

  if (root) {
    root.setAttribute("id", "mainContent");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    "data-rehydratable": getRehydratableName(GlobalHeader.displayName)
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, showSkipLink && /*#__PURE__*/React.createElement("a", {
    className: getSlipLinkClassName(),
    href: "#mainContent"
  }, skipLinkText), leftItems && /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "leftItems"
    })
  }, leftItems), rightItems && /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "rightItems"
    })
  }, rightItems)));
};

GlobalHeader.displayName = "GlobalHeader";
GlobalHeader.displaySkipLinkName = "SkipLink";
/* eslint-disable max-len */

GlobalHeader.propTypes = {
  /**
   * Child nodes to appear on left hand side. Should be GlobalHeader.Item wrapped in a `<React.Fragment />`.
   */
  leftItems: PropTypes.node,

  /**
   * Child nodes to appear on right hand side. Should be GlobalHeader.Item wrapped in a `<React.Fragment />`.
   */
  rightItems: PropTypes.node,

  /**
   * Boolean prop to show/hide `SkipLink`.
   */
  showSkipLink: PropTypes.bool,

  /**
   * Text prop to display text for `SkipLink`.
   */
  skipLinkText: PropTypes.string
};
GlobalHeader.defaultProps = {
  /**
   * Default boolean prop value to show/hide `SkipLink`.
   */
  showSkipLink: true,

  /**
   * Default text prop value to display text for `SkipLink`.
   */
  skipLinkText: "Skip to main content"
};
GlobalHeader.BaseItem = BaseItem;
GlobalHeader.Cart = Cart;
GlobalHeader.Column = Column;
GlobalHeader.Item = Item;
GlobalHeader.Login = Login;
GlobalHeader.NavList = NavList;
GlobalHeader.NavItem = NavItem;
GlobalHeader.LanguageSelector = LanguageSelector;
export default GlobalHeader;